import PropTypes from 'prop-types'
import Input from '../../ui/Input'
import LinkButton from '../../ui/LinkButton'

export const Responder = ({
  idUsuarioChat,
  idMensaje,
  usuario,
  handleChange,
  texto,
  errores,
  mensaje,
  submitRespuesta,
  valido
}) => {
  return (
    usuario &&
    usuario === idUsuarioChat && (
      <div className="row mt-2">
        <div className="col-9">
          <Input
            type="text"
            name={`mensaje-${idMensaje}`}
            value={texto[`mensaje-${idMensaje}`] || ''}
            onChange={(e) => handleChange(e, `mensaje-${idMensaje}`)}
            className="buscar"
            placeholder="Escribe tu respuesta"
            errores={errores}
          />
        </div>

        <div className="col">
          <LinkButton
            className="btn btn-preguntar"
            onClick={(e) => {
              e.preventDefault()
              const value = texto[`mensaje-${idMensaje}`] || ''
              if (valido(value)) {
                submitRespuesta(idMensaje, value, mensaje)
              }
            }}
          >
            Responder
          </LinkButton>
        </div>
      </div>
    )
  )
}

Responder.propTypes = {
  idUsuarioChat: PropTypes.number,
  idMensaje: PropTypes.number.isRequired,
  usuario: PropTypes.number,
  handleChange: PropTypes.func.isRequired,
  texto: PropTypes.objectOf(PropTypes.string).isRequired,
  errores: PropTypes.object.isRequired,
  mensaje: PropTypes.object.isRequired,
  submitRespuesta: PropTypes.func.isRequired,
  valido: PropTypes.func.isRequired
}
